import { useSelector } from "react-redux";
import { isFeatureAccessible } from "../../../global/constants/licensesConstants";
import { isCompanionV2 } from "../../../global/utility/devicesUtils";

export const useHistoricalSearchEligibility = (companionId) => {
  const isV1OnlyAccount = useSelector((state) => state.licenseReducer.isV1OnlyAccount);
  const companionDeviceList = useSelector((state) => state.deviceReducer.companionDeviceList);
  const isHsFlagEnabled = window.REACT_APP_HISTORICAL_SEARCH_ENABLED === "true";
  return isFeatureAccessible(isHsFlagEnabled, isV1OnlyAccount) && isCompanionV2(companionDeviceList, companionId);
};
